<template>
    <div>
        <h2>{{ store.lexicon[store.culture].PRFormReview }}</h2>

        <div class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview1 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormName }}:</strong>
            {{ store.formData.FirstName }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormName3 }}:</strong>
            {{ store.formData.LastName }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormOrg }}:</strong>
            {{ store.formData.Organization }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormPhone }}:</strong>
            {{ store.formData.PhoneNumber }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormEmail }}:</strong>
            {{ store.formData.Email }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview7 }}</strong>
            {{ (store.formData.ForGovernment == 1 ? 'Yes' : 'No') }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview8 }}</strong>
            {{ (store.formData.ForMedia == 1 ? 'Yes' : 'No') }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview9 }}</strong>
            {{ (store.formData.ForLegal == 1 ? 'Yes' : 'No') }}
            <br />
        </div>
        <div v-if="store.formData.Types.includes('Police')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview10 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview11 }}</strong>
            {{ store.formData.Police.CaseNumber }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview12 }}</strong>
            {{ store.formData.Police.PersonInvolvedName }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview13 }}</strong>
            {{ (isDayJS(store.formData.Police.PersonInvolvedDob) ? formatDate(store.formData.Police.PersonInvolvedDob) : null) }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview14 }}</strong>
            {{ store.formData.Police.PersonInvolvedRelation }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRPolice9 }}</strong>
            {{ (isDayJS(store.formData.Police.IncidentDate) ? formatDate(store.formData.Police.IncidentDate) : null) }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview16 }}</strong>
            {{ store.formData.Police.IncidentTime }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormMedical8 }}</strong>
            {{ store.formData.Police.IncidentLocation }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview18 }}</strong>
            {{ store.formData.Police.Details }}
            <br />
        </div>
        <div v-if="store.formData.Types.includes('Emergency')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview19 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview20 }}</strong>
            {{ store.formData.Emergency.Types.join(', ') }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview21 }}</strong>
            {{ store.formData.Emergency.IncidentDateTime }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview18 }}</strong>
            {{ store.formData.Emergency.Details }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview23 }}</strong>
            {{ store.formData.Emergency.IncidentRelationship }}
            <br />
        </div>
        <div v-if="store.formData.Types.includes('CCTV')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview24 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview11 }}</strong>
            {{ store.formData.Cctv.CaseNumber }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRPolice9 }}</strong>
            {{ (isDayJS(store.formData.Cctv.IncidentDate) ? formatDate(store.formData.Cctv.IncidentDate) : null) }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview16 }}</strong>
            {{ store.formData.Cctv.IncidentTime }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormMedical8 }}</strong>
            {{ store.formData.Cctv.Location }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview18 }}</strong>
            {{ store.formData.Cctv.Details }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview30 }}</strong>
            {{ store.formData.Cctv.Reason }}
            <br />
        </div>
        <div v-if="store.formData.Types.includes('Bodycam')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview31 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview11 }}</strong>
            {{ store.formData.Bodycam.CaseNumber }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRPolice9 }}</strong>
            {{ (isDayJS(store.formData.Bodycam.IncidentDate) ? formatDate(store.formData.Bodycam.IncidentDate) : null) }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview16 }}</strong>
            {{ store.formData.Bodycam.IncidentTime }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRBodyCam7 }}</strong>
            {{ store.formData.Bodycam.IncidentDescription }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview30 }}</strong>
            {{ store.formData.Bodycam.Reason }}
            <br />
        </div>
        <div v-if="store.formData.Types.includes('Medical')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview37 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview38 }}</strong>
            {{ store.formData.Medical.PatientName }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRPolice9 }}</strong>
            {{ (isDayJS(store.formData.Medical.IncidentDate) ? formatDate(store.formData.Medical.IncidentDate) : null) }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview16 }}</strong>
            {{ store.formData.Medical.IncidentTime }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormMedical8 }}</strong>
            {{ store.formData.Medical.IncidentLocation }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview42 }}</strong>
            {{ store.formData.Medical.AssistanceLocation }}
            <br />
        </div>
        <div v-if="store.formData.Types.includes('Access')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview43 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview30 }}</strong>
            {{ store.formData.Access.Details }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview45 }}</strong>
            {{ store.formData.Access.BadgeholderName }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview46 }}</strong>
            {{ store.formData.Access.DatesAndTimes }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview47 }}</strong>
            {{ store.formData.Access.BadgeNumber }}
            <br />

            <strong>UPID:</strong>
            {{ store.formData.Access.Upid }}
            <br />
        </div>
        <div v-if="store.formData.Types.includes('Contract')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview48 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview49 }}</strong>
            {{ store.formData.Contract.RequestNumber }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview50 }}</strong>
            {{ store.formData.Contract.ProjectTitle }}
            <br />

            <strong>{{ store.lexicon[store.culture].PRFormReview51 }}</strong>
            {{ store.formData.Contract.RequestedRecords.join(', ') }}
            {{ store.formData.Contract.OtherRecordType != null ? (', ' + store.formData.Contract.OtherRecordType) : null }}
            <br />
        </div>

        <div v-if="store.formData.Types.includes('Other')" class="mb-3">
            <h3>--- {{ store.lexicon[store.culture].PRFormReview52 }} ---</h3>

            <strong>{{ store.lexicon[store.culture].PRFormReview18 }}</strong>
            {{ store.formData.Other.Details }}
            <br />
        </div>

        <h2>{{ store.lexicon[store.culture].PRFormReview54 }}</h2>

        <div class="mb-3">
            {{ store.lexicon[store.culture].PRFormReview55 }}
        </div>
        <div class="mb-3">
            {{ store.lexicon[store.culture].PRFormReview56 }} <a href="https://cdn.portofportland.com/pdfs/PRR%20Price%20List.pdf" target="_blank">{{ store.lexicon[store.culture].PRFormReview57 }}</a>.
        </div>
        <div class="mb-3">
            {{ store.lexicon[store.culture].PRFormReview58 }}
        </div>
        <div class="mb-3">
            {{ store.lexicon[store.culture].PRFormReview59 }}
        </div>
        <div class="mb-3">
            <input type="checkbox" v-model="store.ackBox" />
            {{ store.lexicon[store.culture].PRFormReview60 }}
        </div>

        <div class="form-group col-sm-12">
            <div class="d-flex flex-column align-items-center">
                <recaptcha ref="recaptchaEl" :site-key="store.recaptchaSiteKey" @solved="recaptchaCallback"></recaptcha>
            </div>
        </div>

        <div class="error mb-2" v-if="store.errors.AnyError">{{ store.lexicon[store.culture].PRFormReview61 }}</div>

        <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-primary me-2" @click="store.formData.Types.length > 0 ? goBackToTypePage(store.formData.Types.length - 1) : goBackToPage('TYPE')">{{ store.lexicon[store.culture].Back }}</button>

            <button type="button" class="btn btn-primary" @click="submit" :disabled="!submitEnabled">{{ store.lexicon[store.culture].PRFormNav22 }}</button>
        </div>
    </div>
</template>

<script setup>
    import { computed, ref } from 'vue';
    import * as dayjs from 'dayjs';
    import { useStore } from './store.js';
    import recaptcha from '../../../components/recaptcha';
    import 'messenger';

    const emit = defineEmits(['goBackToPage', 'goBackToTypePage']);

    const props = defineProps({
        isDayJS: Function,
        formatDate: Function,
        validateAll: Function
    });

    const recaptchaResult = ref('');
    const recaptchaPassed = ref(false);
    const recaptchaEl = ref(null);

    const store = useStore();

    const submitEnabled = computed(() => {
        return store.ackBox && recaptchaPassed.value;
    });

    function goBackToPage(pageName) {
        emit('goBackToPage', pageName);
    }

    function goBackToTypePage(index) {
        emit('goBackToTypePage', index);
    }

    const isDayJS = (dateTime) => {
        return props.isDayJS(dateTime);
    }

    const formatDate = (dateTime) => {
        return props.formatDate(dateTime);
    }

    function recaptchaCallback(newState) {
        recaptchaPassed.value = !!newState;

        recaptchaResult.value = newState ? recaptchaEl.value.getResponse() : null;
    }

    const validateAll = () => {
        return props.validateAll();
    }

    function submit() {
        var self = this;

        if (!validateAll()) {
            return;
        }

        store.ackBox = false;

        store.formData['g-recaptcha-response'] = recaptchaResult.value;

        var dataToSend = $.extend(true, {}, store.formData);

        dataToSend.ForGovernment = store.formData.ForGovernment == "1" ? true : false;
        dataToSend.ForMedia = store.formData.ForMedia == "1" ? true : false;
        dataToSend.ForLegal = store.formData.ForLegal == "1" ? true : false;

        if (isDayJS(dataToSend.Police.PersonInvolvedDob)) {
            dataToSend.Police.PersonInvolvedDob = dayjs(dataToSend.Police.PersonInvolvedDob).toISOString();
        }
        else {
            dataToSend.Police.PersonInvolvedDob = dayjs(0).toISOString();
        }

        if (isDayJS(dataToSend.Police.IncidentDate)) {
            dataToSend.Police.IncidentDate = dayjs(dataToSend.Police.IncidentDate).toISOString();
        }
        else {
            dataToSend.Police.IncidentDate = dayjs(0).toISOString();
        }

        if (isDayJS(dataToSend.Cctv.IncidentDate)) {
            dataToSend.Cctv.IncidentDate = dayjs(dataToSend.Cctv.IncidentDate).toISOString();
        }
        else {
            dataToSend.Cctv.IncidentDate = dayjs(0).toISOString();
        }

        if (isDayJS(dataToSend.Bodycam.IncidentDate)) {
            dataToSend.Bodycam.IncidentDate = dayjs(dataToSend.Bodycam.IncidentDate).toISOString();
        }
        else {
            dataToSend.Bodycam.IncidentDate = dayjs(0).toISOString();
        }

        if (isDayJS(dataToSend.Medical.IncidentDate)) {
            dataToSend.Medical.IncidentDate = dayjs(dataToSend.Medical.IncidentDate).toISOString();
        }
        else {
            dataToSend.Medical.IncidentDate = dayjs(0).toISOString();
        }

        if (dataToSend.Contract.OtherRecordType != null) {
            dataToSend.Contract.RequestedRecords += ', ' + dataToSend.Contract.OtherRecordType;
        }

        Messenger().run({
            action: $.ajax,
            successMessage: "Public Records Request Submitted",
            errorMessage: "Error submitting Public Records Request",
            progressMessage: "Submitting...",
            retry: {
                auto: false
            }
        },
            {
                method: "POST",
                url: store.submitUrl,
                data: dataToSend,
                success: function () {
                    store.currentPage = 'SUCCESS';
                }
            });
    }

</script>
